import { render, staticRenderFns } from "./YoutubeWidget.vue?vue&type=template&id=a9ff46d4&"
import script from "./YoutubeWidget.vue?vue&type=script&lang=js&"
export * from "./YoutubeWidget.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeWidget.vue?vue&type=style&index=0&id=a9ff46d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports